import { useState } from "react";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { memberSchema } from "../../../../models/member";
import MemberService from "../../../../services/member_service";

/**
 * useProfileForm
 * 
 * Responsabilidade única: edição de dados do membro via Formik.
 * Gerencia o estado de edição, submit, reset e troca de foto.
 * 
 * @param {Object} member - Dados atuais do membro
 * @param {Function} setMember - Setter para atualizar o membro após salvar
 * @param {string} idTenant - ID do tenant
 * @param {Object} user - Usuário logado
 */
const useProfileForm = (member, setMember, idTenant, user) => {
    const [isEditing, setIsEditing] = useState(false);

    const formik = useFormik({
        initialValues: member || {},
        validationSchema: memberSchema,
        enableReinitialize: true,
        onSubmit: async (values) => {
            try {
                await MemberService.save(values, idTenant, user);
                setMember(prev => ({ ...prev, ...values }));
                setIsEditing(false);
                toast.success("Membro atualizado com sucesso!");
            } catch (err) {
                console.error("Erro ao salvar:", err);
                toast.error("Ocorreu um erro ao salvar membro.");
            }
        }
    });

    const handleEdit = () => {
        setIsEditing(true);
    };

    const handleSave = () => {
        formik.handleSubmit();
    };

    const handleCancelEdit = () => {
        formik.resetForm();
        setIsEditing(false);
    };

    const handlePhotoChange = async (base64Str) => {
        formik.setFieldValue("photoUrl", base64Str);
    };

    return {
        formik,
        isEditing,
        handleEdit,
        handleSave,
        handleCancelEdit,
        handlePhotoChange,
    };
};

export default useProfileForm;
